import type { UserData } from './types/user_data';

export function getCsvLinesFromUserList(
  userList: Backbone.Collection<Backbone.Model<UserData>>,
  callback: { (err: Error | null, csvLines: string[][]): void },
): void {
  if (app.userRoleList && !app.userRoleList.hasBeenFetched()) {
    app.userRoleList.once('reset', () => {
      getCsvLinesFromUserList(userList, callback);
    });
    void app.userRoleList.fetch({ reset: true });
    return;
  }

  const lines: string[][] = [];
  lines.push(['Email Address', 'First Name', 'Last Name', 'Role', 'Location Access']);
  userList.models.forEach((user) => {
    const userRoleId = user.get('userRoleId');
    if (!userRoleId) {
      throw new Error('User is missing a role.');
    }
    const userRole = app.userRoleList?.get(userRoleId);
    if (!userRole) {
      throw new Error(`User role ${userRoleId} not found.`);
    }
    const username = user.get('username');
    const userRoleName = userRole.get('name');
    if (!username || !userRoleName) {
      throw new Error('User list contains incomplete user data.');
    }
    lines.push([
      username,
      user.get('firstName') || '',
      user.get('lastName') || '',
      userRoleName,
      getLocationGroupName(user.get('locationGroupId')),
    ]);
  });

  callback(null, lines);
}

function getLocationGroupName(locationGroupId: string | undefined): string {
  if (!locationGroupId) {
    throw new Error('Bite users should not show up in this list.');
  }
  const locationGroup = app.locationGroupList.get(locationGroupId);
  return locationGroup.displayNameAsListFieldElement(true);
}
